import styled from "styled-components";

import {
	COLOR_TEXT_PRIMARY_B2C,
	DESKTOP_M_BP,
	MOBILE_L_BP,
	FONT_WT_MEDIUM,
	FONT_WT_LIGHT,
} from "@website-builder/utilities-index";
export const Container = styled.div`
	padding-top: 50px;
	height: 635px;
	display: flex;

	@media only screen and (max-width: ${MOBILE_L_BP}px) {
		flex-direction: column;
		height: unset;
	}
`;

export const LeftContainer = styled.div`
	width: 50%;
	display: flex;
	justify-content: center;
	align-items: center;
	padding: 0px 155px 0px 155px;

	@media only screen and (max-width: ${MOBILE_L_BP}px) {
		width: 100%;
	}
`;

export const ImageContainer = styled.div`
	width: 50%;
	display: flex;
	align-items: center;
	@media only screen and (max-width: ${MOBILE_L_BP}px) {
		width: 100%;
		padding: 20px;
	}
`;

export const Title = styled.h1`
	font-weight: ${FONT_WT_MEDIUM};
	font-size: 36px;
	line-height: 42px;

	color: ${COLOR_TEXT_PRIMARY_B2C};

	@media only screen and (max-width: ${MOBILE_L_BP}px) {
		font-size: 28px;
		margin-top: 50px;
	}
`;
export const Subtitle = styled.h3`
	font-weight: ${FONT_WT_LIGHT};
	font-size: 16px;
	line-height: 26px;
	color: ${COLOR_TEXT_PRIMARY_B2C};
	display: ${(props) => !props.show && "none"};

	@media only screen and (max-width: ${MOBILE_L_BP}px) {
		text-align: center;
		max-width: 202px;
		margin: 0px;
	}
`;
export const InputContainer = styled.div`
	margin: 6px 0px 6px 0px;
	box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.05);

	input {
		font-weight: ${FONT_WT_LIGHT};
		font-size: 16px;
		line-height: 24px;
		color: ${COLOR_TEXT_PRIMARY_B2C};
		::placeholder {
			color: #a7a7a7;
		}
		width: 100%;
		padding: 14px;
		border: none;
	}

	color: #a7a7a7;
	.dropdown-not-selected {
		color: #a7a7a7 !important;
	}
	.dropdown {
		border: none !important;
		padding: 15px;
	}
`;

export const Form = styled.form`
	width: 300px;

	display: ${(props) => !props.show && "none"};

	@media only screen and (max-width: ${MOBILE_L_BP}px) {
		margin-top: 20px;
		margin-bottom: 50px;
	}
`;

export const Image = styled.div`
	img {
		height: 440px;

		@media only screen and (max-width: ${DESKTOP_M_BP}px) {
			height: unset;
			width: 100%;
		}
	}
`;

export const ButtonContainer = styled.div`
	margin-top: 16px;
	button {
		width: 100%;
	}
`;

export const FormContainer = styled.div`
	display: flex;
	flex-direction: column;
	@media only screen and (max-width: ${MOBILE_L_BP}px) {
		align-items: center;
	}
`;

export const SuccessMessage = styled.div`
	color: ${COLOR_TEXT_PRIMARY_B2C};
	font-weight: ${FONT_WT_LIGHT};
	font-size: 16px;
	line-height: 26px;
	display: flex;
	height: 300px;
	width: 300px;
	align-items: center;
	@media only screen and (max-width: ${MOBILE_L_BP}px) {
		justify-content: center;
	}
`;
